<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii">Flesh</a></h1><a id="page_iii">
<p class="title"><br/></p>
<p class="author">Philip José Farmer</p>
<p class="author">
<img alt="images" src="images/logo.jpg"/>
</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?2d5d715e